const ListIssuersComponent = () => import('../views/issuers/IssuersComponent.vue')
let path = '/issuers/'

export const IssuersRoutes = [
    {
        path: `${path}list`,
        name: 'listIssuer',
        component: ListIssuersComponent
    },
]